import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux"; // ✅ ADD REDUX DISPATCH
import { getUserProfile } from "../services/authServices";
import { Spin } from "antd";
import { Logger } from '../utils/logger';
import toast from 'react-hot-toast';
// ✅ ADD REDUX ACTIONS (same as auth pages)
import { setUserDetails, userPreferences } from "../actions/actions";

export default function PrivateRoute({ children }) {
  const dispatch = useDispatch(); // ✅ ADD DISPATCH HOOK
  const [isLoading, setIsLoading] = useState(true);
  const data = localStorage.getItem("auth_token");

  const fetchUserProfile = async () => {
    // Check if we fetched recently (within last 5 minutes)
    const lastFetch = localStorage.getItem("last_profile_fetch");
    const now = Date.now();
    
    if (lastFetch && now - parseInt(lastFetch) < 300000) { // 5 minutes
      setIsLoading(false);
      return;
    }

    try {
      const response = await getUserProfile();

      if (response?.data) {
        // ✅ UPDATE localStorage (existing)
        localStorage.setItem("userData", JSON.stringify(response?.data?.data));
        localStorage.setItem(
          "user_preferences",
          JSON.stringify(response.data.data.userPreference)
        );
        localStorage.setItem("last_profile_fetch", now.toString());
        
        // ✅ UPDATE REDUX (same as auth pages) - ON SUCCESS
        dispatch(setUserDetails(response?.data?.data));
        
        if (response.data.data.userPreference) {
          dispatch(userPreferences(response.data.data.userPreference));
        }
        
        Logger.log("[PrivateRoute] Profile refreshed in both localStorage and Redux");
      }
    } catch (error) {
      Logger.log(`[ERROR] ${error.message}`);

      // Show friendly message to user before logout
      if (error.response?.status === 401) {
        toast.error(
          'You are being logged out. This may be due to:\n• Unauthorized access\n• Usage on more than one device at a time\n• Session expired',
          {
            duration: 3000,
            style: {
              background: '#ef4444',
              color: '#fff',
              padding: '16px',
              borderRadius: '8px',
            },
            icon: '🔒',
          }
        );

        // Wait a moment before clearing storage so user can see the message
        await new Promise(resolve => setTimeout(resolve, 2000));
      }

      // ✅ SIMPLE: Just logout on any error (especially 401 from your API)
      localStorage.removeItem("auth_token");
      localStorage.removeItem("userData");
      localStorage.removeItem("user_preferences");
      localStorage.removeItem("last_profile_fetch");

      // ✅ CLEAR REDUX STATE
      dispatch(setUserDetails({}));
      dispatch(userPreferences({}));
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (data) fetchUserProfile();
    else setIsLoading(false);
  }, [data]);

  if (isLoading) {
    return (
      <div className="vh-100 w-100 d-flex align-items-center justify-content-center">
        <Spin size="large" tip="Loading..." spinning={true}></Spin>
      </div>
    );
  }

  return data ? children : <Navigate to="/" />;
}